import { IconAlertCircle } from '@tabler/icons-react'
import type { ReactNode } from 'react'

/* Shown when a resource fails to load (410 Gone, network error, etc.) */
export function ResourceUnavailable({ label }: { label: string }): ReactNode {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12 text-center">
      <IconAlertCircle className="size-8 text-muted-foreground" />
      <p className="text-sm text-muted-foreground">
        This {label} is no longer available
      </p>
    </div>
  )
}
